function CircleCheck(){
  return (
    <svg width="67" height="68" viewBox="0 0 67 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.833 35.5833L30.333 45.0833L46.1663 26.0833" stroke="#FF5D17" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M33.4997 65.6666C50.9887 65.6666 65.1663 51.4889 65.1663 33.9999C65.1663 16.5109 50.9887 2.33325 33.4997 2.33325C16.0107 2.33325 1.83301 16.5109 1.83301 33.9999C1.83301 51.4889 16.0107 65.6666 33.4997 65.6666Z" stroke="#FF5D17" strokeWidth="3"/>
    </svg>
  )
}
export default CircleCheck;